module.exports = __webpack_public_path__ + "img/lost.dd04f7f2.svg";